import { render, staticRenderFns } from "./PrivateRoom.vue?vue&type=template&id=0ff6f122&scoped=true"
import script from "./PrivateRoom.vue?vue&type=script&lang=js"
export * from "./PrivateRoom.vue?vue&type=script&lang=js"
import style0 from "./PrivateRoom.vue?vue&type=style&index=0&id=0ff6f122&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff6f122",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff6f122')) {
      api.createRecord('0ff6f122', component.options)
    } else {
      api.reload('0ff6f122', component.options)
    }
    module.hot.accept("./PrivateRoom.vue?vue&type=template&id=0ff6f122&scoped=true", function () {
      api.rerender('0ff6f122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/battleground/components/PrivateRoom.vue"
export default component.exports